export const CHANNELS_V4_RECEIVED = '@ZAPI_CHANNELS_V4_RECEIVED';
export const CHANNEL_DETAILS_V4_RECEIVED = '@ZAPI_CHANNEL_DETAILS_V4_RECEIVED';
export const FAVORITES_RECEIVED = '@ZAPI_CHANNELS_FAVORITES_RECEIVED';
export const FAVORITES_UPDATED = '@ZAPI_CHANNELS_FAVORITES_UPDATED';
